export class CommonHelper {



    static delay(ms = 1000) {
        return new Promise((resolve) => setTimeout(resolve, ms))
    }


    static generateGradientColors(startColor, endColor, steps) {
        const hexToRgb = (hex) => {
            const parsed = hex.replace(/^#/, "");
            const bigint = parseInt(parsed, 16);
            return {
                r: (bigint >> 16) & 255,
                g: (bigint >> 8) & 255,
                b: bigint & 255,
            };
        };

        const rgbToHex = ({
                r,
                g,
                b
            }) =>
            "#" + [r, g, b]
            .map((x) => {
                const hex = x.toString(16);
                return hex.length === 1 ? "0" + hex : hex;
            })
            .join("");

        const start = hexToRgb(startColor);
        const end = hexToRgb(endColor);
        const colors = [];

        for (let i = 0; i < steps; i++) {
            const ratio = i / (steps - 1);
            const r = Math.round(start.r + (end.r - start.r) * ratio);
            const g = Math.round(start.g + (end.g - start.g) * ratio);
            const b = Math.round(start.b + (end.b - start.b) * ratio);
            colors.push(rgbToHex({
                r,
                g,
                b
            }));
        }

        return colors;
    }



    static jsonToFormData(obj, form = new FormData(), namespace = '') {
        for (let property in obj) {
            const value = obj[property];
            const formKey = namespace ? `${namespace}[${property}]` : property;

            if (value instanceof Date) {
                form.append(formKey, value.toISOString());
            } else if (value instanceof File || value instanceof Blob) {
                    console.log('value instanceof File || value instanceof Blob', value);
                
                // form.append(formKey, value);
            } else if (Array.isArray(value)) {
                value.forEach((element, index) => {
                    const tempKey = typeof element === 'object' && !(element instanceof File) ?
                        `${formKey}[${index}]` :
                        `${formKey}[]`;

                    if (element instanceof File || element instanceof Blob) {
                        form.append(tempKey, element);
                    } else if (typeof element === 'object' && element !== null) {
                        this.jsonToFormData(element, form, tempKey); // recursively flatten nested object
                    } else {
                        form.append(tempKey, element);
                    }
                });
            } else if (typeof value === 'object' && value !== null) {
                this.jsonToFormData(value, form, formKey); // recursively flatten nested object
            } else {
                form.append(formKey, value);
            }
        }
    }
}